import { useSession } from '~/contexts/SessionContext';
import { useRouter } from 'next/router';

export default function useIsMyLocker() {
  const session = useSession();
  const router = useRouter();
  return session.user?.username === router.query.username ?? false;
}
